module.exports = __webpack_public_path__ + "static/media/3.ca194d41.png";